import { __ } from "@wordpress/i18n";
import {
	useBlockProps,
	InspectorControls,
	PanelColorSettings,
	AlignmentControl,
	BlockControls,
	
} from "@wordpress/block-editor";
import {
	PanelBody,
	RangeControl,
	SelectControl,
	TextControl,
	TextareaControl,
	ToggleControl,
} from "@wordpress/components";
import { Fragment, useEffect } from "@wordpress/element";

import "./editor.scss";

export default function Edit({ attributes, setAttributes }) {
	const {
		separators,
		tagline,
		taglineInput,
		color,
		separatorWidth,
		separatorHeight,
		taglineFontSize,
		taglineSpacing,
		taglineColor,
		textAlign,
		prefixColor,
		separatorGap,
		svgInput,
		removeBefore,
		removeAfter
	} = attributes;

	const getStyles = () => ({
		position: 'relative',
		'--separator-width': `${separatorWidth}% `,
		'--separator-gap': `${separatorGap}px`,
		'--separator-color': color,
		'--separator-height': `${separatorHeight}px`,
		'--tagline-size': `${taglineFontSize}px`,
		'--tagline-spacing': `${taglineSpacing}px`,
		'--tagline-color': taglineColor,
		'--prefix-color': prefixColor,
	});

	useEffect(() => {
		if (["style6", "style7", "custom"].includes(separators)) {
			setAttributes({ tagline: true });
		}
	}, [separators, setAttributes]);;

	return (
		<div {...useBlockProps({ className: `align-${textAlign}` })}>
			<Fragment>
				<InspectorControls>
					<BlockControls>
						<AlignmentControl
							value={textAlign}
							onChange={(nextAlign) => {
								setAttributes({ textAlign: nextAlign });
							}}
						/>

					</BlockControls>
					<PanelBody
						title={__("Separator Designs", "templazee")}
						initialOpen={true}
					>
						<div className="separator-style-options">
							{[
								{ label: "Style 1", value: "style1" },
								{ label: "Style 2", value: "style2" },
								{ label: "Style 3", value: "style3" },
								{ label: "Style 4", value: "style4" },
								{ label: "Style 5", value: "style5" },
								{ label: "Style 6", value: "style6" },
								{ label: "Style 7", value: "style7" },
								{ label: "Custom Separator", value: "custom" },
							].map((option) => (
								<button
									key={option.value}
									className={`separator-option ${option.value} ${separators === option.value ? "active" : ""
										}`}
									onClick={() => setAttributes({ separators: option.value })}
								>
									<div className={`separator-preview ${option.value}`}>
										{/* Add specific previews for each separator style */}
										{["style1", "style3"].includes(option.value) && (
											<>
												<div className="beforeStyle"></div>
												<div className="center-part"></div>
												<div className="left-part"></div>
												<div className="afterStyle"></div>
											</>
										)}
										{option.value === "style2" && (
											<div className="dotted-line"></div> /* Example for a dotted separator */
										)}
										{["style6", "style7"].includes(option.value) && (
											<>
												<div className="beforeStyle"></div>
												<div className="tagline">Tagline</div>
												<div className="afterStyle"></div>
											</>
										)}
									</div>
									<span>{option.label}</span>
								</button>
							))}
						</div>
						{!["custom"].includes(separators) || (
							<>
								<TextareaControl
									label={__("Svg Input")}
									value={svgInput}
									onChange={(newValue) => setAttributes({ svgInput: newValue })}
								/>
							</>
						)}
					</PanelBody>
					<PanelBody
						title={__("Separator Settings", "templazee")}
						initialOpen={false}
					>
						{["custom"].includes(separators) || (
							<>
								<PanelColorSettings
									title={__("Color Settings")}
									colorSettings={[
										{
											value: color,
											onChange: (color) => setAttributes({ color: color }),
											label: __("Separator Color"),
										},
										...(["style6", "style7"].includes(separators)
											? [
												{
													value: taglineColor,
													onChange: (color) => setAttributes({ taglineColor: color }),
													label: __("Tagline Color"),
												},
											]
											: []),
									]}
								/>

								{(separators === "style7") && (
									<RangeControl
										label={__("Separator Gap")}
										value={separatorGap}
										onChange={(value) => setAttributes({ separatorGap: value })}
										min={1}
										max={20}
									/>
								)}
								<RangeControl
									label={__("Separator Width")}
									value={separatorWidth}
									onChange={(value) => setAttributes({ separatorWidth: value })}
									min={10}
									max={100}
								/>

								<RangeControl
									label={__("Separator Height")}
									value={separatorHeight}
									onChange={(value) => setAttributes({ separatorHeight: value })}
									min={1}
									max={20}
								/>
								{!["style6", "style7"].includes(separators) || (
									<>
										<TextControl
											label={__("Tagline Input")}
											value={taglineInput}
											onChange={(newValue) => setAttributes({ taglineInput: newValue })}
										/>
										<RangeControl
											label={__("Tagline Font Size")}
											value={taglineFontSize}
											onChange={(value) => setAttributes({ taglineFontSize: value })}
											min={8}
											max={100}
										/>
										<RangeControl
											label={__("Letter Spacing")}
											value={taglineSpacing}
											onChange={(value) => setAttributes({ taglineSpacing: value })}
											min={0}
											max={20}
										/>
										<ToggleControl
											label={__("Remove Line ( Before )", "templazee")}
											checked={removeBefore}
											onChange={(isRemove) => setAttributes({ removeBefore: isRemove })}
										/>
										<ToggleControl
											label={__("Remove Line ( After )", "templazee")}
											checked={removeAfter}
											onChange={(isRemove) => setAttributes({ removeAfter: isRemove })}
										/>
									</>
								)}
							</>
						)}

						
					</PanelBody>
				</InspectorControls>
				<div
					className={`templazee-separator align-${textAlign}`}
					style={{ display: "flex", justifyContent: textAlign, alignItems: "center", position: "relative" }}>
					<div
						className={`${separators}`}
						style={getStyles()}
					>
						{separators === 'style1' && <div className="center-part">
						</div>}

						{separators === 'style3' && <div className="left-part">
						</div>}
						{(separators === 'style7' || separators === 'style6') &&
							<span>
								{removeBefore !== true && <div className="beforeStyle"></div>}
								<div>{tagline && (taglineInput || "Tagline")}</div>
								{removeAfter !== true && <div className="afterStyle" ></div>}
							</span>}

						{(separators === 'custom') &&
							<span>
								<div dangerouslySetInnerHTML={{ __html: svgInput }} />
							</span>}
					</div>
				</div>
			</Fragment>
		</div>
	);
}